import {myFirebase} from "../firebase/firebase";

// get all parents or all babysitters.
export async function getGroupData(type) {
    try {
        let snapshot = await myFirebase.firestore().collection('members').where("type", "==", type).get();
        return snapshot.docs.map(doc => doc.data())
    }catch (e) {
        console.log(e)
    }
}

// get a specific user by email.
export async function getUserDataByMail(email) {
    try {
        let snapshot = await myFirebase.firestore().collection('members').where("email", "==", email).get();
        let answer = snapshot.docs.map(doc=>doc.data());
        return answer[0];
    } catch (e) {
        console.log(e)
    }
}
